import { render } from "./CreateInstructions.vue?vue&type=template&id=518f66b4&scoped=true"
import script from "./CreateInstructions.vue?vue&type=script&lang=js"
export * from "./CreateInstructions.vue?vue&type=script&lang=js"

import "./CreateInstructions.vue?vue&type=style&index=0&id=518f66b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518f66b4"]])

export default __exports__